import React from "react";
import { getAutoPassList } from "../../core/utils";
import TextInput from "react-autocomplete-input";
import "react-autocomplete-input/dist/bundle.css";
import { MultiSelect } from "react-multi-select-component";

const autoPassListOptions = getAutoPassList().map((item) => {
  return { label: item, value: item };
});
const UnderwritingAdmission = ({ state, setState, number }) => {
  const autoPassList = getAutoPassList();
  return (
    <div>
      <div className="mx-4">
        <div className="row my-3">
          <div className="col-sm-12 mb-2">
            <h6 className="fw-bold">
              {number}. Have you been admitted to hospital for 24 hours or
              longer in the past 5 years?
            </h6>{" "}
          </div>
          <div className="col-sm-12 text-danger mb-2">
            <em>
              (including psychiatric institutions and rehabilitation facilities,
              but excludes admission for childbirth (females only))
            </em>
          </div>
          <div className="col-sm-12 mb-2">
            <div className="row mx-2">
              <div
                className="col-sm-2 form-check"
                onClick={() => {
                  setState({ ...state, admitted: true });
                }}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  checked={state.admitted}
                ></input>
                <label className="form-check-label" htmlFor="refund1">
                  Yes
                </label>
              </div>
              <div
                className="col-sm-2 form-check"
                onClick={() => {
                  setState({ ...state, admitted: false });
                }}
              >
                <input
                  className="form-check-input"
                  type="radio"
                  checked={state.admitted == false}
                ></input>
                <label className="form-check-label" htmlFor="refund2">
                  No
                </label>
              </div>
            </div>
          </div>
          {!!state.admitted && (
            <div className="col-sm-12 mb-2">
              <div className="col-lg-8 mb-2">
                <div className="form-group row mb-3">
                  <div className="col-sm-12 mb-2">
                    <h6 className="fw-bold mt-4">
                      For which condition/symptom (s) or complaint were you
                      hospitalised?
                    </h6>{" "}
                  </div>

                  <div className="col-sm-8 ">
                    <MultiSelect
                      options={autoPassListOptions}
                      value={state.conditionOrComplaintHospitalizedFor}
                      onChange={(val) => {
                        setState({
                          ...state,
                          conditionOrComplaintHospitalizedFor: val,
                        });
                      }}
                      isCreatable={true}
                      onCreateOption={(value) => ({
                        label: value.toUpperCase(),
                        value: value.toUpperCase(),
                      })}
                      labelledBy="Select"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default UnderwritingAdmission;
